import { render, staticRenderFns } from "./CouponRules.vue?vue&type=template&id=47e7d6d1&scoped=true&"
import script from "./CouponRules.vue?vue&type=script&lang=js&"
export * from "./CouponRules.vue?vue&type=script&lang=js&"
import style0 from "./CouponRules.vue?vue&type=style&index=0&id=47e7d6d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7d6d1",
  null
  
)

export default component.exports